import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './components/features/auth/Login';
import Public from './components/public/Public';
import MenuList from './components/main/menu/Index';
import ScheduleReservation from './components/main/reserv/ScheduleReservation.js'
import OrderOnline from './components/main/orderOnline/OrderOnline.js'
import About from './components/main/aboutUs/About.js'
import HoursLocation from './components/main/hoursLocation/HoursLocation.js'
import ShopOnline from './components/main/shop/ShopOnline.js'
import BackToTopButton from './components/BackToTop/BackToTop.js';
import Prefetch from './features/auth/Prefetch.js';
import ScheduleReservationForm from './components/main/reserv/ScheduleReservationForm.js';
import ConfirmationPage from './components/confirmation/ConfirmationPage.js';
import Success from './components/main/orderOnline/Success.js';
import Cancel from './components/main/orderOnline/Cancel.js'
import Approved from './components/main/orderOnline/Approved.js';
import NewOrder from './components/main/orderOnline/NewOrder.js'

import CartProvider from './features/cartContext/CartContext.js';
import OrderProvider from './features/cartContext/OrderContext.js';
import ShoppingCart from './components/main/orderOnline/ShoppingCart.js';
import Notification from './components/notifications/Notification.js';
import CheckOut from './components/main/orderOnline/CheckOut.js';
import Mentenance from './components/404_Page/Mentenance.js';
import Promotion from './components/promotions/Promotion.js';
// import Cancel from './components/main/orderOnline/Cancel.js';
import { Toaster } from "react-hot-toast";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";

function App() {

  const initialOptions = {
   "client-id": "AczD65tI747pqpv3un94ZL6QJkC_slRn1zoLH1pman5b_H78GsLZLJoVmzaam_4RffPyRV4niLXsQL3r",    
    currency: "USD",
    intent: "capture",
  };

  return (
    <>
      <Toaster />
      <PayPalScriptProvider options={initialOptions}>
        <CartProvider>
          <OrderProvider>
            <div className="App">
              <Routes>
                <Route element={<Prefetch />}>
                  <Route path='/' element={<Layout />}>
                    <Route index element={<Public />} />
                    <Route path='Home' element={<Public />} />
                    <Route path='Menu' element={<MenuList />} />
                    <Route path='BookaTable'>
                      <Route index element={<ScheduleReservation />} />
                      <Route path="new" element={<ScheduleReservationForm />} />
                      <Route path="confirmation" element={<ConfirmationPage />} />
                    </Route>

                    <Route path='OnlineOrdering'>
                      <Route index element={<OrderOnline />} />
                      <Route path="cart" element={<NewOrder />} />
                      <Route path="checkOut" element={<CheckOut />} />
                      <Route path="Success" element={<Success />} />
                      <Route path="cancel" element={<Cancel />} />
                      <Route path="Approved" element={<Approved />} />

                    </Route>
                    <Route path='Promotion'>
                      <Route index element={<Promotion />} />
                    </Route>

                    <Route path='Notifications' element={<Notification />} />
                    <Route path='About' element={<About />} />
                    <Route path='HoursLocations' element={< HoursLocation />} />
                    <Route path='Shop' element={<ShopOnline />} />
                    <Route path='login' element={<Login />} />
                    <Route path='mantenance' element={<Mentenance />} />
                    <Route path='cancel' element={<Cancel />} />

                  </Route>
                </Route>

              </Routes>
              {/* <BackToTopButton /> */}
            </div>
          </OrderProvider>
        </CartProvider>
      </PayPalScriptProvider>
    </>

  );
}

export default App;
